var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTbaBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    width: 512,
    height: 512,
    transform: "translate(-113.8 -140.1) scale(.8)",
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\ANINDYA\\\\\\\\Downloads\\\\\\\\calendar_2409619.png"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 29.5,
    width: 150.1,
    height: 131.2,
    rx: 12,
    ry: 12,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 11.3,
    width: 18.6,
    height: 36.4,
    rx: 9.2,
    ry: 9.2,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.3,
    y: 11.3,
    width: 18.6,
    height: 36.4,
    rx: 9.2,
    ry: 9.2,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.8,
    y1: 64.7,
    x2: 34.7,
    y2: 64.7,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 76,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 76,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.4,
    y: 76,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.5,
    y: 76,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 106.3,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 106.3,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 106.3,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.6,
    y: 106.3,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 134,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 134,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 134,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.6,
    y: 134,
    width: 20,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.9,
    cy: 146,
    r: 44.9,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9,140.3c-.4-.5-.8-1-1-1.6l-2.6-7.6c-1.4-3.6-4.4-3.2-4.4-3.2h-26.3s-3-.3-4.4,3.2l-2.6,7.6c-.2.6-.5,1.1-1,1.6-1,1.1-2.8,3.3-2.9,5.3v7.7c0,.9.2,1.8.7,2.5.7,1,1.9,1.9,4.4,1.9h37.7c2.4,0,3.7-1,4.4-1.9.5-.7.7-1.6.7-2.5v-7.7c0-2-1.9-4.2-2.9-5.3Z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.7,
    y1: 140.3,
    x2: 71.9,
    y2: 140.3,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 146.3,
    width: 8.3,
    height: 6,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.3,
    y: 146.2,
    width: 8.3,
    height: 6,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.3,
    y1: 147.4,
    x2: 56.4,
    y2: 147.4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.3,
    y1: 149.3,
    x2: 56.4,
    y2: 149.3,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.3,
    y1: 151.1,
    x2: 56.4,
    y2: 151.1,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,157.7v3.3c0,1.8-1.5,3.3-3.3,3.3h-3.6c-1.8,0-3.3-1.5-3.3-3.3v-8.8",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7,157.7v3.3c0,1.8,1.5,3.3,3.3,3.3h3.6c1.8,0,3.3-1.5,3.3-3.3v-8.8",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTbaBooking);
export default __webpack_public_path__ + "static/media/icon-tba-booking.e157ee7e364bbac3efb3cde87ecabe2b.svg";
export { ForwardRef as ReactComponent };